

  var swiper = new Swiper("#btab-slider", {
    slidesPerView: "4",
    spaceBetween:10,

    speed:900,
    autoplay: {
    delay:3000,
    disableOnInteraction: false,
    
  },
          navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
     breakpoints: {
    0: {
      slidesPerView:2.1,
      spaceBetween:8,
    },
    768: {
      slidesPerView:3.5,
      spaceBetween:10,
    },
    1024: {
      slidesPerView:4,
      spaceBetween:10,
    },
  },
  });

    var swiper = new Swiper("#bheart-slider", {
      slidesPerView: "4",
      spaceBetween:10,

            navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
          speed:900,
    autoplay: {
    delay:3000,
    disableOnInteraction: false,
    
  },
           breakpoints: {
    0: {
      slidesPerView:2.1,
      spaceBetween:8,
    },
    768: {
      slidesPerView:3.5,
      spaceBetween:10,
    },
    1024: {
      slidesPerView:4,
      spaceBetween:10,
    },
  },
    });



var swiper = new Swiper("#Blogs-Slider", {
  slidesPerView:4,
  spaceBetween: 30,
    speed:900,
    autoplay: {
    delay:3000,
    disableOnInteraction: false,
    
  },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },

  breakpoints: {
    0: {
      slidesPerView: 2.1,
      spaceBetween: 8,
    },
   768: {
      slidesPerView:3.5,
      spaceBetween:10,
    },
    1024: {
      slidesPerView:4,
      spaceBetween:30,
    },
  },
});
var swiper = new Swiper("#Big-Review-slider", {
  slidesPerView:4,
  spaceBetween: 30,
    speed:900,
    autoplay: {
    delay:3000,
    disableOnInteraction: false,
    
  },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },

  breakpoints: {
    0: {
      slidesPerView:1.6,
      spaceBetween:8,
    },
   768: {
      slidesPerView:3.5,
      spaceBetween:10,
    },
    1024: {
      slidesPerView:4,
      spaceBetween:30,
    },
  },
});



var swiper1 = new Swiper("#reviews-sliders", {
    spaceBetween: 30,
    grabCursor:true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    speed:900,
  pagination: {
        el: ".swiper-pagination",
    clickable: true,
      },
  });

